import { render } from "./LoginPage.vue?vue&type=template&id=706c7ba4&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=706c7ba4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bayes-intraday-pwa-rt/bayes-intraday-pwa-rt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706c7ba4"]])

export default __exports__